import { ArrowLeft } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface BackButtonProps {
  onClick?: () => void;
  to?: string;
  children?: React.ReactNode;
  variant?: 'default' | 'glass';
  className?: string;
  showText?: boolean;
}

export const BackButton = ({ 
  onClick, 
  to, 
  children, 
  variant = 'default',
  className,
  showText = true 
}: BackButtonProps) => {
  const navigate = useNavigate();
  const baseClasses = cn(
    "inline-flex items-center gap-2 transition-all duration-300",
    variant === 'glass' 
      ? "px-4 py-2 backdrop-blur-lg bg-white/10 border border-white/20 rounded-xl text-white hover:bg-white/20 transform hover:scale-105 min-h-[44px]" 
      : "text-gray-600 hover:text-[#F39800] transition-colors",
    className
  );

  const content = (
    <>
      <ArrowLeft size={variant === 'glass' ? 20 : 20} className={variant === 'glass' ? "" : "w-5 h-5"} />
      {showText && (
        <span className="hidden sm:inline text-sm font-medium">
          {children || '뒤로'}
        </span>
      )}
    </>
  );

  if (to) {
    return (
      <Link to={to} className={baseClasses} aria-label="뒤로가기">
        {content}
      </Link>
    );
  }

  return (
    <button onClick={onClick || (() => navigate(-1))} className={baseClasses} aria-label="뒤로가기">
      {content}
    </button>
  );
};